import { JuloUpdateEntry } from "./types"

export const beroendenTillaggsorderEntry: JuloUpdateEntry = {
  slug: "2026-07-09-beroenden-tillaggsorder",
  date: "2026-07-09",
  title: "Beroenden i tilläggsordrar",
  description:
    'Nu går det att lägga till beroenden även i tilläggsordrar, precis som i besiktningsprotokollet. Klicka på de tre prickarna på en åtgärd och välj "Beror på", så kan ni markera vilken annan åtgärd i ordern den beror på. Kunden ser sedan beroendet när de godkänner tilläggsordern och kan inte godkänna åtgärden utan att också godkänna det den beror på.',
  images: [
    {
      src: "/julo-updates/2026-07-09-beroenden-tillaggsorder/beroenden-tillaggsorder.png",
      alt: "Komponentåtgärden Byt bromsbelägg fram i en tilläggsorder med tre-prickars-menyn öppen som visar alternativen Lägg till rabatt, Beror på och Ta bort åtgärd.",
    },
  ],
}
